import logisticTripControlPointsService from "../shared/services/logisticTripControlPointsService";

const REQUEST_LOGISTIC_CP_ALARM = "REQUEST_LOGISTIC_CP_ALARM";
const RESPONSE_LOGISTIC_CP_ALARM = "RESPONSE_LOGISTIC_CP_ALARM";
const REQUEST_LOGISTIC_CP_ALARM_FAILURE = "REQUEST_LOGISTIC_CP_ALARM_FAILURE";

const requestUpdateLogisticCPAlarmAction = () => {
  return {
    type: REQUEST_LOGISTIC_CP_ALARM,
  };
};

const responseUpdateLogisticCPAlarmAction = () => {
  return {
    type: RESPONSE_LOGISTIC_CP_ALARM,
  };
};

const requestUpdateLogisticCPAlarmFailureAction = (errors) => {
  return {
    type: REQUEST_LOGISTIC_CP_ALARM_FAILURE,
    errors,
  };
};

const updateLogisticControlPointAlarm = (options) => {
  return (dispatch) => {
    dispatch(requestUpdateLogisticCPAlarmAction());

    logisticTripControlPointsService
      .updateTripControlPointAlarm(options)
      .then((result) => {
        dispatch(responseUpdateLogisticCPAlarmAction());
      })
      .catch((error) => {
        dispatch(requestUpdateLogisticCPAlarmFailureAction(error.response));
      });
  };
};

const REQUEST_LOGISTIC_CP_VARIATION = "REQUEST_LOGISTIC_CP_VARIATION";
const RESPONSE_LOGISTIC_CP_VARIATION = "RESPONSE_LOGISTIC_CP_VARIATION";
const REQUEST_LOGISTIC_CP_VARIATION_FAILURE = "REQUEST_LOGISTIC_CP_VARIATION_FAILURE";

const requestUpdateLogisticCPVariationAction = () => {
  return {
    type: REQUEST_LOGISTIC_CP_VARIATION,
  };
};

const responseUpdateLogisticCPVariationAction = () => {
  return {
    type: RESPONSE_LOGISTIC_CP_VARIATION,
  };
};

const requestUpdateLogisticCPAVariationFailureAction = (errors) => {
  return {
    type: REQUEST_LOGISTIC_CP_VARIATION_FAILURE,
    errors,
  };
};

const updateLogisticControlPointVariation = (options) => {
  return (dispatch) => {
    dispatch(requestUpdateLogisticCPVariationAction());

    logisticTripControlPointsService
      .updateTripControlPointVariation(options)
      .then((result) => {
        dispatch(responseUpdateLogisticCPVariationAction());
      })
      .catch((error) => {
        dispatch(requestUpdateLogisticCPAVariationFailureAction(error.response));
      });
  };
};

export {
  REQUEST_LOGISTIC_CP_ALARM,
  RESPONSE_LOGISTIC_CP_ALARM,
  REQUEST_LOGISTIC_CP_ALARM_FAILURE,
  updateLogisticControlPointAlarm,
  REQUEST_LOGISTIC_CP_VARIATION,
  RESPONSE_LOGISTIC_CP_VARIATION,
  REQUEST_LOGISTIC_CP_VARIATION_FAILURE,
  updateLogisticControlPointVariation,
};
